<template>
  <div>
    <template v-if="multiple">
      <el-checkbox-group v-model="answerCheck" @change="changeAnswerCheck">
        <el-checkbox v-for="item in optionsList" :key="item.title" :label="item.title"></el-checkbox>
      </el-checkbox-group>
    </template>

    <template v-else>
      <el-radio-group v-model="answerRadio" @change="changeAnswerRadio">
        <el-radio v-for="item in optionsList" :key="item.title" :label="item.title"></el-radio>
      </el-radio-group>
    </template>
  </div>
</template>

<script>
export default {
  name: 'bc-standard-answer',
  props: {
    options: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          let list = JSON.parse(val)
          console.log(list)
          if (this.multiple) {
            this.answerCheck = list.map(i => i.title)
          } else {
            this.answerRadio = list.map(i => i.title).join()
          }
        }

      },
      immediate: true
    },
    options: {
      handler(val) {
        try {
          this.optionsList = JSON.parse(val)
        } catch (err) {
          this.optionsList = []
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      answerCheck: [],
      answerRadio: '',
      optionsList: []
    }
  },
  methods: {
    changeAnswerRadio() {
      let list = this.optionsList.filter(i => i.title === this.answerRadio)
      this.$emit('input', JSON.stringify(list))
    },
    changeAnswerCheck() {
      let list = this.optionsList.filter(i => this.answerCheck.some(x => i.title === x))
      this.$emit('input', JSON.stringify(list))
    },
  }

}
</script>

<style scoped>

</style>
